module.exports = "https://static.cdns.space/classicbook-temp-tx/img/2-3.ae92b935.jpg";